<template>
  <vs-popup
    :title="titlePopUp"
    :active.sync="activatingPopUp"
    @close="closeWithLoad(false)"
    class="p-5"
  >
    <main class="mt-2 w-full">
      <div class="flex flex-wrap items-center mb-base">
        <img
          :src="
            formData.file !== null
              ? formData.file.includes('upload//')
                ? `${url.baseFl}/${formData.file}`
                : formData.file
              : formData.file
          "
          alt="hewan-qurban-img"
          class="rounded-lg shadow-md cursor-pointer block w-full mb-4"
        />
        <div class="vx-row w-full justify-between items-start">
          <div class="vx-col sm:w-full lg:w-1/2 xl:w-1/2 flex justify-start">
            <input
              type="file"
              class="hidden"
              ref="updateImgInput"
              @change="updateCurrImg"
              accept="image/*"
            />
            <vs-button class="mr-4 sm:mb-0 mb-2" @click="$refs.updateImgInput.click()"
              >Upload Foto Hewan</vs-button
            >
            <!-- <p class="text-sm mt-2">Allowed JPG, GIF or PNG. Max size of 800kB</p> -->
          </div>
          <!-- <div class="vx-col sm:w-full lg:w-1/2 xl:w-1/2 flex justify-end">
            <p class="text-red">Ukuran Rekomendasi : 1365 x 404</p>
          </div> -->
        </div>
      </div>
      <!-- Info -->
      <div class="mb-6" v-if="katQurban === undefined && subKatQurban === undefined">
        <p class="text-lg text-danger">
          Kategori dan sub-kategori ZIS Qurban tidak ditemukan!. Silahkan hubungi admin
          untuk menambahkan kategori dan sub-kategori ZIS bernama Qurban.
        </p>
      </div>
      <div class="mb-6">
        <section class="mb-4 flex justify-start gap-1">
          <h6><strong>Jenis Hewan</strong></h6>
          <span class="text-danger">*</span>
        </section>
        <v-select
          :options="hewan_qurban"
          :reduce="(v) => v.id"
          class="w-full"
          v-validate="'required'"
          data-vv-validate-on="blur"
          name="animal type"
          label="name"
          v-model="formData.hewan"
          placeholder="Pilih Jenis Hewan"
        />
        <span class="text-danger text-sm">{{ errors.first("animal type") }}</span>
      </div>
      <div class="mb-6">
        <section class="flex justify-between items-end">
          <div class="mb-4 flex justify-start gap-1">
            <h6><strong>Judul</strong></h6>
            <span class="text-danger">*</span>
          </div>
          <p class="mb-1 text-sm text-grey">Max. 50</p>
        </section>
        <!-- <input
          type="text"
          v-model="formData.name"
          v-validate="'required'"
          data-vv-validate-on="blur"
          name="name"
          class="w-full sidebar-input"
          placeholder="Isi Dengan Nama Hewan Qurban"
          maxlength="50"
        /> -->
        <vs-input
          v-validate="'required'"
          data-vv-validate-on="blur"
          name="title"
          maxlength="50"
          class="w-full sidebar-input"
          v-model="formData.name"
          placeholder="Isi Dengan Judul Qurban"
        />
        <span class="text-danger text-sm">{{ errors.first("title") }}</span>
      </div>
      <div class="mb-6" v-if="hewanFinder">
        <section class="mb-4 flex justify-start gap-1">
          <h6><strong>Tipe</strong></h6>
          <span class="text-danger">*</span>
        </section>
        <v-select
          :disabled="hewanFinder.name == 'KAMBING'"
          :options="hargaList"
          :reduce="(v) => v.id"
          class="w-full"
          v-validate="'required'"
          data-vv-validate-on="blur"
          name="type"
          label="name"
          v-model="formData.status"
          placeholder="Pilih Tipe"
        />
        <span class="text-danger text-sm">{{ errors.first("type") }}</span>
      </div>
      <div class="mb-6">
        <section class="mb-4 flex justify-start gap-1">
          <h6><strong>Harga (Rp)</strong></h6>
          <span class="text-danger">*</span>
        </section>
        <vs-input
          @keypress="onlyNumber"
          v-validate="'required'"
          data-vv-validate-on="blur"
          name="price"
          class="w-full sidebar-input"
          v-model="nominal"
          placeholder="Isi Dengan Harga"
        />
        <span class="text-danger text-sm">{{ errors.first("price") }}</span>
      </div>
      <div class="mb-6">
        <section class="mb-4 flex justify-start gap-1">
          <h6><strong>Berat Hewan (Kg)</strong></h6>
          <span class="text-danger">*</span>
        </section>
        <section class="flex justify-start gap-2 items-center">
          <div>
            <vs-input
              @keypress="onlyNumber"
              v-validate="'required'"
              data-vv-validate-on="blur"
              name="weight from"
              class="w-full sidebar-input"
              v-model="beratDari"
              placeholder="Berat Dari..."
            />
            <span class="text-danger text-sm">{{ errors.first("weight from") }}</span>
          </div>
          <span class="text-3xl"><strong> - </strong></span>
          <div>
            <vs-input
              @keypress="onlyNumber"
              v-validate="'required'"
              data-vv-validate-on="blur"
              name="weight to"
              class="w-full sidebar-input"
              v-model="beratSampai"
              placeholder="Berat Sampai..."
            />
            <span class="text-danger text-sm">{{ errors.first("weight to") }}</span>
          </div>
        </section>
      </div>
      <div class="mb-6">
        <section class="mb-4 flex justify-start gap-1">
          <h6><strong>Tanggal Mulai</strong></h6>
          <span class="text-danger">*</span>
        </section>
        <flat-pickr
          class="w-full sidebar-input"
          :config="configFromdateTimePicker"
          v-model="formData.mulai"
          placeholder="Tentukan Tanggal Mulai"
          @on-change="onFromChange"
        />
        <span v-if="formData.mulai === ''" class="text-danger text-sm"
          >Start date cannot be empty</span
        >
      </div>
      <div class="mb-6">
        <section class="mb-4 flex justify-start gap-1">
          <h6><strong>Tanggal Selesai</strong></h6>
          <span class="text-danger">*</span>
        </section>
        <vs-input
          v-if="formData.mulai === ''"
          :disabled="true"
          class="w-full sidebar-input"
          placeholder="Tentukan Tanggal Selesai"
        />
        <flat-pickr
          v-else
          class="w-full sidebar-input"
          :config="configTodateTimePicker"
          v-model="formData.selesai"
          placeholder="Tentukan Tanggal Selesai"
          @on-change="onToChange"
        />
        <span v-if="formData.selesai === ''" class="text-danger text-sm"
          >End date cannot be empty</span
        >
      </div>
      <div class="mb-6">
        <section class="mb-4 flex justify-start gap-1">
          <h6><strong>Deskripsi</strong></h6>
          <span class="text-danger">*</span>
        </section>
        <vs-textarea
          v-validate="'required'"
          data-vv-validate-on="blur"
          name="description"
          class="w-full sidebar-input"
          v-model="formData.description"
          placeholder="Isi Dengan Deskripsi"
        />
        <span class="text-danger text-sm">{{ errors.first("description") }}</span>
      </div>
      <div class="vx-row mb-8 items-center">
        <p class="vx-col lg:w-1/2 md:w-1/2 sm:w-full justify-start">
          <strong>Aktifasi</strong>
        </p>
        <div class="vx-col lg:w-1/2 md:w-1/2 sm:w-full flex gap-2 justify-end">
          <p>{{ statusSelect ? "Aktif" : "Tidak Aktif" }}</p>
          <vs-switch
            :color="statusSelect ? 'success' : 'danger'"
            v-model="statusSelect"
          />
        </div>
      </div>
    </main>
    <footer class="mt-4">
      <div class="flex justify-end items-center mr-4 mb-4">
        <vs-button color="danger" class="mr-2 rounded-2xl" @click="closeWithLoad(false)"
          >Cancel</vs-button
        >
        <vs-button
          color="success"
          :disabled="!validateForm"
          class="ml-2 rounded-2xl"
          @click="addWithOption"
          >{{ labelButton }}</vs-button
        >
      </div>
    </footer>
  </vs-popup>
</template>
<script>
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import emptyImage from "@/assets/images/elements/empty.png";
import url from "@/url.js";

export default {
  components: {
    flatPickr,
  },
  props: {
    activate: { type: Boolean, default: false },
    passData: { type: Object, default: null },
  },
  data() {
    return {
      url,
      emptyImage,
      priodeList: [],
      configFromdateTimePicker: {
        minDate: null,
        maxDate: new Date("2022-07-12"),
        enableSeconds: true,
        enableTime: true,
        time_24hr: true,
        dateFormat: "Y-m-d H:i:S",
      },
      configTodateTimePicker: {
        minDate: null,
        maxDate: new Date("2022-07-12"),
        enableSeconds: true,
        enableTime: true,
        time_24hr: true,
        dateFormat: "Y-m-d H:i:S",
      },
      beratDari: "",
      beratSampai: "",
      statusSelect: true,
      formData: {
        user_id: "",
        kat_id: "",
        sub_id: "",
        name: "",
        hewan: "",
        berat: "",
        nominal: "",
        status: "",
        description: "",
        mulai: "",
        selesai: "",
        status_active: "",
        file: emptyImage,
      },
      hargaList: [
        {
          id: "1",
          name: "Full",
        },
        {
          id: "2",
          name: "1/7",
        },
      ],
      hewan_qurban: [
        {
          id: "1",
          name: "SAPI",
        },
        {
          id: "4",
          name: "KAMBING",
        },
      ],
      binaryFile: "",
    };
  },
  computed: {
    titlePopUp() {
      return this.passData != null ? "Edit Hewan Qurban" : "Tambah Hewan Qurban";
    },
    profile() {
      return this.$store.state.auth.profileAccess.profile;
    },
    nominal: {
      get() {
        return this.formatRupiah(this.formData.nominal);
      },
      set(val) {
        // Do something with the val here...
        this.formData.nominal = val;
      },
    },
    labelButton() {
      return this.passData != null ? "Edit" : "Submit";
    },
    katQurban() {
      return this.$store.getters["zis/getIdKategori"]("Qurban");
    },
    subKatQurban() {
      return this.$store.getters["zis/getIdSubKategori"]("Qurban");
    },
    validateForm() {
      return (
        !this.errors.any() &&
        this.formData.name !== "" &&
        this.formData.nominal !== "" &&
        this.formData.mulai !== "" &&
        this.formData.selesai !== "" &&
        this.beratDari !== "" &&
        this.beratSampai !== "" &&
        this.katQurban !== undefined &&
        this.subKatQurban !== undefined &&
        this.formData.hewan !== "" &&
        this.formData.description !== "" &&
        this.formData.file !== this.emptyImage &&
        this.formData.status !== ""
      );
    },
    activatingPopUp: {
      get() {
        return this.activate;
      },
      set(val) {
        this.$emit("callback", val);
      },
    },
    hewanTypeSelect() {
      return this.formData.hewan;
    },
    hewanFinder() {
      return this.hewan_qurban.find((v) => v.id == this.formData.hewan);
    },
  },
  watch: {
    // nominal() {
    //   console.log(this.nominal);
    //   this.formData.nominal = this.$options.filters.toCurrency(this.formData.nominal);
    // },
    hewanTypeSelect() {
      let hewanQurban = this.formData.hewan !== "" ? this.hewanFinder.name : "";
      if (hewanQurban === "KAMBING") {
        this.formData.status = "1";
      }
    },
    statusSelect() {
      if (this.statusSelect) {
        this.formData.status_active = "1";
      } else {
        this.formData.status_active = "2";
      }
    },
    activate() {
      if (this.passData !== null) {
        this.formData.name = this.passData.name;
        this.formData.status = this.passData.status.toString();
        this.beratDari = this.passData.berat.split("-")[0];
        this.beratSampai = this.passData.berat.split("-")[1];
        this.formData.status_active = this.passData.status_active.toString();
        this.statusSelect = this.passData.status_active === 1;
        this.formData.hewan = this.hewan_qurban
          .find((v) => v.name === this.passData.hewan)
          .id.toString();
        this.nominal = this.passData.nominal.toString();
        this.formData.mulai = this.passData.mulai;
        this.formData.selesai = this.passData.selesai;
        this.formData.file = this.getPathFoto(this.passData);
        this.formData.description = this.passData.description;
      } else {
        this.resetForm();
      }
    },
  },
  methods: {
    textLimit($event) {
      if (this.formData.name.value.lenght <= 50) {
        $event.preventDefault();
        console.log(this.formData.name.lenght);
      }
    },
    formatToRupiah() {
      if (this.formData.nominal != "") {
        var num = this.formData.nominal;

        num = new Intl.NumberFormat("id-ID", {
          style: "currency",
          currency: "IDR",
        }).format(num);

        this.formData.nominal = num;
      }
    },

    resetForm() {
      this.formData.name = "";
      this.formData.status = "";
      this.formData.kat_id = "";
      this.formData.sub_id = "";
      this.formData.berat = "";
      this.formData.hewan = "";
      this.formData.nominal = "";
      this.formData.mulai = "";
      this.formData.selesai = "";
      this.beratDari = "";
      this.beratSampai = "";
      this.statusSelect = true;
      this.formData.file = this.emptyImage;
      this.formData.description = "";
    },
    onFromChange(selectedDates, dateStr) {
      this.$set(this.configTodateTimePicker, "minDate", dateStr);
    },
    onToChange(selectedDates, dateStr) {
      this.$set(this.configFromdateTimePicker, "maxDate", dateStr);
    },
    closeWithLoad(load) {
      this.activatingPopUp = false;
      this.$emit("withClose", load);
    },
    addWithOption() {
      this.$vs.loading({
        color: "primary",
      });
      console.log(this.passData);
      if (this.binaryFile === "") {
        this.addData();
      } else {
        this.addWithFile();
      }
    },
    addWithFile() {
      this.$store
        .dispatch("file/addFile", this.binaryFile)
        .then((v) => {
          this.formData.file = v.link;
          this.addData();
        })
        .catch((e) => {
          this.$vs.loading.close();
          this.binaryFile = "";
          if (e.response) {
            console.error(e.response.status);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          } else {
            console.error(e);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: "Terjadi kesalahan, silahkan periksa jaringan anda",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        });
    },
    addData() {
      let id = {};
      if (this.passData !== null) {
        id = {
          id: this.passData.id,
        };
      }
      if (this.formData.file === emptyImage) {
        this.formData.file = null;
      }

      if (this.formData.file === this.emptyImage) {
        this.formData.file = "";
      }

      this.formData.nominal = this.formData.nominal.replaceAll(".", "");
      this.formData.berat = `${this.beratDari}-${this.beratSampai}`;
      this.formData.user_id = this.profile.id.toString();
      this.formData.kat_id = this.katQurban.id.toString();
      this.formData.sub_id = this.subKatQurban.id.toString();
      this.$store
        .dispatch("qurban/cudQurban", [{ ...this.formData, ...id }])
        .then((v) => {
          this.$vs.loading.close();
          this.$vs.notify({
            position: "top-right",
            title:
              this.passData !== null ? "Edit Qurban Sukses!" : "Tambah Qurban Sukses!",
            text:
              this.passData !== null
                ? `Qurban ${v.name} Berhasil diedit`
                : `Qurban ${v.name} Berhasil ditambah`,
            iconPack: "feather",
            icon: "icon-smile",
            color: "primary",
          });
          this.closeWithLoad(true);
        })
        .catch((e) => {
          this.$vs.loading.close();

          if (e.response) {
            console.error(e.response.status);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        })
        .finally(() => {
          this.resetForm();
        });
    },
    updateCurrImg(input) {
      if (input.target.files && input.target.files[0]) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.formData.file = e.target.result;
          this.binaryFile = input.target.files[0];
        };
        reader.readAsDataURL(input.target.files[0]);
      }
    },
  },
};
</script>

<style>
.text-red {
  color: red;
}
.text-blue {
  color: blue;
}
.text-grey-black {
  color: rgb(70, 70, 70);
}
img {
  max-height: 270px;
  overflow: auto;
  object-fit: cover;
}
</style>
